// @flow
import styled, { css } from 'styled-components';
import { albasterGrey, errorBg, errorText, blackGrey, mercuryGrey, daveGrey, silverGrey, flamingo } from '../../colors';
/*::
import type { Node } from 'react';
import type { InputThemeType } from '..';
*/

var InputTheme
/*: InputThemeType */
= {
  // default theme
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1sgs76p-0"
  })(["position:relative;width:100%;height:5.6rem;"]),
  Input: styled.input.withConfig({
    displayName: "theme__Input",
    componentId: "sc-1sgs76p-1"
  })(["box-sizing:border-box;position:relative;background-color:", ";padding:2.5rem 1rem 1rem 1rem;", " height:5.6rem;width:100%;color:", ";font-size:1.6rem;font-weight:300;", " border:none;border-radius:0.8rem 0.8rem 0 0;outline:none;transition:all 0.3s ease-out;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border-bottom:1px solid ", ";&:focus{color:", ";border-bottom:1px solid ", ";}&[type='password']{font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;}&::-webkit-input-placeholder{font-family:'Futura PT';}&:-ms-input-placeholder{font-family:'Futura PT';}&::placeholder{font-family:'Futura PT';}"], function (pr) {
    return pr.error ? errorBg() : albasterGrey();
  }, function (pr) {
    return pr.withIcon && css(["padding-right:3rem;"]);
  }, daveGrey(), function (pr) {
    return pr.disabled ? css(["background-color:", ";color:", ";cursor:not-allowed;"], mercuryGrey(), daveGrey()) : '';
  }, function (pr) {
    return pr.error ? errorText() : silverGrey();
  }, blackGrey(), function (pr) {
    return pr.error ? errorText() : flamingo();
  }),
  Icon: styled.div.withConfig({
    displayName: "theme__Icon",
    componentId: "sc-1sgs76p-2"
  })(["box-sizing:border-box;position:absolute;right:1rem;top:50%;transform:translateY(-50%);height:1.6rem;width:1.6rem;"])
};
export default InputTheme;